import React, { useEffect } from 'react';
import './quoteordermodal.css';
import QuoteOrder from './quoteorder';
import NewQuote from './newquote';

const QuoteOrderModal = ({ showModal, toggleModal, quote, onQuoteUpdated }) => {
  // Add/remove class to App when modal opens/closes
  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (showModal) {
      appElement?.classList.add('quoteorder-open');
    } else {
      appElement?.classList.remove('quoteorder-open');
    }
    
    // Cleanup on unmount
    return () => {
      appElement?.classList.remove('quoteorder-open');
    };
  }, [showModal]);

  if (!showModal) {
    return null;
  }

  const handleQuoteUpdate = (updatedQuote) => {
    if (onQuoteUpdated && updatedQuote) {
      onQuoteUpdated(updatedQuote);
    }
    toggleModal();
  };

  return (
    <div className="quoteordermodal-overlay">
      <div className="quoteordermodal-content">
        {quote ? (
          <QuoteOrder quote={quote} onClose={handleQuoteUpdate} />
        ) : (
          <NewQuote onQuoteCreated={handleQuoteUpdate} onCancel={toggleModal} />
        )}
      </div>
    </div>
  );
};

export default QuoteOrderModal; 